import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { campaign, campaignList } from './fixtures/campaign.fixture';
import {
  getDraftOffer,
  getOffer,
  getOfferDistributionSettings,
  offers,
  sendOffer,
} from './fixtures/offers-domain.fixture';
import { programs } from './fixtures/programs.fixture';

export const listProgramsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/programs`,
    fn,
  );

export const listCampaignsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/merchants/campaigns`,
    fn,
  );

export const getCampaignMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/merchants/:merchantId/programs/:programId/campaigns/:campaignId`,
    fn,
  );

export const createCampaignsMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/merchants/:merchantId/programs/:programId/campaigns`,
    fn,
  );

export const updateCampaignMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/merchants/:merchantId/programs/:programId/campaigns/:campaignId`,
    fn,
  );

export const deleteCampaignMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/merchants/:merchantId/programs/:programId/campaigns/:campaignId`,
    fn,
  );

export const listOffersMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/offers`,
    fn,
  );

export const getOfferMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/offers/:offerId`,
    fn,
  );

export const deleteOfferMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/merchants/:merchants/offers/:offerId`,
    fn,
  );

export const sendOfferMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/offers/:offerId/manualdistribution`,
    fn,
  );

export const deleteCustomerOfferMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/users/:userId/offers/:offerId/delete`,
    fn,
  );

export const updateOfferMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/merchants/:merchantId/offers2/:offerId`,
    fn,
  );

export const getOfferDistributionSettingsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/clients/:clientId/merchants/:merchantId/offers/:offerId/distributionsettings`,
    fn,
  );

export const createDraftOfferMock = fn =>
  rest.post(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-offers-domain/draftoffers`,
    fn,
  );

export const updateDraftOfferMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/draftoffers/:draftOfferId`,
    fn,
  );

export const getDraftOfferMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/draftoffers/:draftOfferId`,
    fn,
  );

export const deleteDraftOfferMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/draftoffers/:draftOfferId`,
    fn,
  );

export const publishDraftOfferMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/draftoffers/:draftOfferId/publish`,
    fn,
  );

export const copyOfferAsDraftMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/offers/:offerId/copyasdraft`,
    fn,
  );

export const copyDraftOfferAsDraftMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-offers-domain/draftoffers/:draftOfferId/copyasdraft`,
    fn,
  );

export const handlers = () => [
  listProgramsMock((_req, res, ctx) => {
    return res(ctx.json(programs));
  }),
  listCampaignsMock((_req, res, ctx) => {
    return res(ctx.json(campaignList));
  }),
  getCampaignMock((_req, res, ctx) => {
    return res(ctx.json(campaign));
  }),
  createCampaignsMock((_req, res, ctx) => {
    return res(
      ctx.json({ campaignId: 'd723297b-1d42-4903-9572-c9c24287d2e4' }),
    );
  }),
  updateCampaignMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  deleteCampaignMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  listOffersMock((req, res, ctx) => {
    if (req.url.searchParams.get('loyaltyoffers') === 'true') {
      return res(
        ctx.json({
          ...offers,
          offers: offers.offers.map(offer => ({
            ...offer,
            isLoyaltyOffer: true,
            title: `Loyalty ${offer.title}`,
          })),
        }),
      );
    }

    return res(ctx.json(offers));
  }),
  getOfferMock((_req, res, ctx) => {
    return res(ctx.json(getOffer));
  }),
  deleteOfferMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  sendOfferMock((_req, res, ctx) => {
    return res(ctx.json(sendOffer));
  }),
  deleteCustomerOfferMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  updateOfferMock((_req, res, ctx) => {
    return res(ctx.json({}));
  }),
  getOfferDistributionSettingsMock((_req, res, ctx) => {
    return res(ctx.json(getOfferDistributionSettings));
  }),
  createDraftOfferMock((_req, res, ctx) => {
    return res(
      ctx.json({
        draftOfferId: '00000000-0000-0000-0000-000000000002',
      }),
    );
  }),
  updateDraftOfferMock((_req, res, ctx) => {
    return res(
      ctx.json({
        draftOfferId: '00000000-0000-0000-0000-000000000002',
      }),
    );
  }),
  getDraftOfferMock((_req, res, ctx) => {
    return res(ctx.json(getDraftOffer));
  }),
  deleteDraftOfferMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  publishDraftOfferMock((_req, res, ctx) => {
    return res(ctx.json({ offerId: '00000000-0000-0000-0000-000000000003' }));
  }),
  copyOfferAsDraftMock((_req, res, ctx) => {
    return res(
      ctx.json({
        draftOfferId: '00000000-0000-0000-0000-000000000004',
      }),
    );
  }),
  copyDraftOfferAsDraftMock((_req, res, ctx) => {
    return res(
      ctx.json({
        draftOfferId: '00000000-0000-0000-0000-000000000005',
      }),
    );
  }),
];
